import React, { useState } from "react";
import { api } from "../api";

export default function BugReport() {

  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [image, setImage] = useState(null);
  const [msg, setMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category || !description.trim()) {
      setMsg("Kategori och beskrivning krävs.");
      return;
    }

    const formData = new FormData();
    formData.append("category", category);
    formData.append("description", description);
    if (image) formData.append("image", image);

    try {
      await api.post("/bugs", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      setMsg("Rapport skickad ✅");
      setCategory("");
      setDescription("");
      setImage(null);
    } catch (err) {
      console.error(err);
      setMsg("Kunde inte skicka rapport.");
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: 700 }}>
      <h3>Rapportera fel</h3>

      {msg && <div className="alert alert-info">{msg}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Kategori</label>
          <select
            className="form-select"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            required
          >
            <option value="">Välj kategori…</option>
            <option value="jobblista">Jobblista</option>
            <option value="jour">Jour</option>
            <option value="semester">Semesteransökan</option>
            <option value="övrigt">Övrigt</option>
            {/* Admin kan få fler kategorier här om du vill rendera dynamiskt */}
          </select>
        </div>

        <div className="mb-3">
          <label className="form-label">Beskrivning</label>
          <textarea
            className="form-control"
            rows="4"
            placeholder="Beskriv problemet…"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          ></textarea>
        </div>

        <div className="mb-3">
          <label className="form-label">Bifoga bild (valfritt)</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={(e) => setImage(e.target.files[0])}
          />
        </div>

        <button type="submit" className="btn btn-primary">
          Skicka
        </button>
      </form>
    </div>
  );
}
